/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Formulary tier a plan assigns to a drug.
 *
 * Tier values are snake_case. Producers may supply either that spelling or
 * the inventory API's camelCase one; :func:`canonical_tier` resolves both.
 *
 * ``OTHER`` stands for a tier outside this vocabulary, mirroring
 * ``MetalTier.OTHER`` / ``MedicalNetworkType.OTHER``. It is deliberately a
 * member of :data:`NOT_COVERED_TIERS`: coverage is claimed only for tiers
 * affirmatively classified as covered, so a tier this vocabulary does not
 * know must not read as covered. Every resolution to ``OTHER`` is logged
 * with the raw value, so the miss cannot pass silently.
 */
export enum DrugTier {
  generic = 'generic',
  brand = 'brand',
  specialty = 'specialty',
  preferred_generic = 'preferred_generic',
  preferred_brand = 'preferred_brand',
  preferred_specialty = 'preferred_specialty',
  non_preferred_generic = 'non_preferred_generic',
  non_preferred_brand = 'non_preferred_brand',
  non_preferred_specialty = 'non_preferred_specialty',
  not_covered = 'not_covered',
  not_listed = 'not_listed',
  non_listed = 'non_listed',
  no_coverage = 'no_coverage',
  other = 'other',
}
